import 'bootstrap/dist/css/bootstrap.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '../node_modules/nprogress/nprogress.css'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

//createApp(App).use(router).mount('#app')

const app = createApp(App);

app.use(router);
app.use(VueToast);

var vm = app.mount("#app");

export { app, vm }

//createApp(App).mount('#app')
